import React from "react";

const CancellationPolicy = () => {
  return (
    <div
      className="container"
      style={{ marginBottom: "150px", marginTop: "100px" }}
    >
      <div className="row">
        <div className="col-12">
          <h1>Política de Cancelamento, Reagendamento e Atendimento OLIS</h1>
          <h3>Telemedicina</h3>

          <h2>1. Cancelamento de Consultas:</h2>
          <h4>a. Cancelamento sem cobrança:</h4>
          <ul>
            <li>
              O cancelamento da consulta poderá ser realizado sem cobrança até
              24 horas antes do horário agendado.
            </li>
            <li>
              O cancelamento deverá ser realizado através do contato da Olis:
              <a href="https://wa.me/5511958799090">11958799090 (whatsApp)</a>
            </li>
            <li>
              Os valores pagos por você pela consulta online serão reembolsados
              pelo profissional no prazo máximo de 14 (quatorze) dias a partir
              do recebimento do seu pedido de cancelamento e usando o mesmo
              método de pagamento usado por você para pagar as taxas (salvo
              acordo contrário).
            </li>
            <li>
              Os cancelamentos, ausências e atrasos superiores ao tempo de
              tolerância descrito abaixo, sujeitam-se a retenção de taxa
              administrativa de 4.95% sobre o valor da consulta, para a
              cobertura dos custos de processamento de pagamento.
            </li>
          </ul>

          <h4>b. Cancelamentos fora do prazo:</h4>
          <ul>
            <li>
              Cancelamentos fora deste prazo, ou o não comparecimento à
              consulta, implicarão na cobrança integral do valor pago, sem
              possibilidade de reembolso.
            </li>
          </ul>

          <h2>2. Reagendamento de Consultas:</h2>
          <ul>
            <li>
              <strong>a.</strong> O reagendamento poderá ser feito uma vez, com
              até 12 horas de antecedência do horário agendado, sem custo
              adicional.
            </li>
            <li>
              <strong>b.</strong> A solicitação de reagendamento poderá ser
              feita através do contato da Olis:
              <a href="https://wa.me/5511958799090">11958799090 (WhatsApp)</a>.
              Ou poderá ser feito através do link de reagendamento enviado para
              o seu whatsapp.
            </li>
            <li>
              <strong>c.</strong> O novo horário deverá ser escolhido de acordo
              com a disponibilidade de horários da plataforma.
            </li>
            <li>
              <strong>d.</strong> Reagendamentos solicitados fora deste prazo
              não serão permitidos, sendo considerado falta na consulta, sem
              direito a reembolso.
            </li>
          </ul>

          <h2>3. Tolerância para Atrasos:</h2>
          <ul>
            <li>
              <strong>a.</strong> A paciente tem até 15 minutos de tolerância
              após o início agendado da consulta para acessar o link da
              teleconsulta.
            </li>
            <li>
              <strong>b.</strong> Após esse período, a consulta será considerada
              perdida (no-show), sendo registrada e cobrada normalmente, sem
              reembolso.
            </li>
          </ul>

          <h2>4. Definição de Não Comparecimento (No-show):</h2>
          <ul>
            <li>
              <strong>a.</strong> Considera-se no-show quando a paciente não
              comparece ou não acessa o link da teleconsulta no tempo previsto,
              sem aviso prévio.
            </li>
            <li>
              <strong>b.</strong> O no-show não será reembolsado e ocupará o
              horário de atendimento previsto.
            </li>
          </ul>

          <h2>5. Plataforma e Acesso:</h2>
          <p>
            A consulta será realizada de forma online, por videochamada, em
            plataforma segura, com link enviado previamente via e-mail ou
            WhatsApp.
          </p>

          <h2>6. Responsabilidades da Paciente:</h2>
          <ul>
            <li>Garantir o acesso à plataforma no horário marcado.</li>
            <li>
              É responsabilidade do paciente verificar previamente sua conexão
              de internet, áudio e câmera, bem como entrar no link no horário
              combinado.
            </li>
            <li>
              Comunicar com antecedência em caso de imprevistos (conforme os
              horários acima especificados).
            </li>
            <li>
              Estar em local reservado, com boa conexão, para preservar o sigilo
              da consulta.
            </li>
            <li>Concordar com os termos de atendimento online da OLIS.</li>
          </ul>

          <h2>7. Contato e Suporte:</h2>
          <p>
            Em caso de problemas técnicos ou dúvidas sobre este termo, o contato
            deverá ser feito pelo WhatsApp: <strong>11958799090</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CancellationPolicy;
